import React from 'react';
import { StarIcon, BellIcon, SettingsIcon } from '../../../assets/icons';

const ProfileCard = ({ user, notificationCount = 0, stats }) => {
  // URL de la imagen del usuario, con fallback a una imagen por defecto
  const getProfileImage = () => {
    if (user?.profileImage || user?.profile_image || user?.avatar) {
      return user.profileImage || user.profile_image || user.avatar;
    }
    // Imagen por defecto
    return 'https://static.vecteezy.com/system/resources/thumbnails/020/765/399/small_2x/default-profile-account-unknown-icon-black-silhouette-free-vector.jpg';
  };

  const getUserDisplayName = () => {
    if (user?.name) return user.name;
    if (user?.first_name && user?.last_name) return `${user.first_name} ${user.last_name}`;
    if (user?.first_name) return user.first_name;
    return 'SAMUEL LOPEZ';
  };

  return (
    <div className="px-4 py-4 flex flex-row items-center justify-between gap-4">
      {/* Avatar */}
      <div className="flex flex-col items-start justify-between flex-shrink-0">
        {/* Avatar Image */}
        <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-300 flex items-center justify-center">
          <img
            src={getProfileImage()}
            alt={`Foto de perfil de ${getUserDisplayName()}`}
            className="w-full h-full object-cover"
            onError={e => {
              // Si la imagen falla al cargar, mostrar imagen por defecto
              e.target.src =
                'https://static.vecteezy.com/system/resources/thumbnails/020/765/399/small_2x/default-profile-account-unknown-icon-black-silhouette-free-vector.jpg';
            }}
          />
        </div>
      </div>

      {/* Nombre y Métricas */}
      <div className="flex flex-col items-start justify-between gap-0 flex-1 min-w-0">
        {/* Parte superior */}
        <div className="flex items-center justify-between w-full mb-5">
          {/* Nombre y Rating */}
          <div className="flex items-center gap-3 min-w-0 flex-1">
            <h2 className="text-md font-bold text-gray-900 whitespace-nowrap truncate">
              {getUserDisplayName()}
            </h2>
            <div className="flex items-center justify-center gap-0.5 flex-shrink-0 bg-gray-400 bg-opacity-40 rounded-md px-1">
              <StarIcon />
              <span className="text-sm font-regular text-gray-900">5.0</span>
            </div>
          </div>

          {/* Iconos */}
          <div className="flex items-center gap-1 flex-shrink-0">
            {/* Icono de campanita */}
            <BellIcon notificationCount={notificationCount} />

            {/* Icono de engranaje */}
            <SettingsIcon />
          </div>
        </div>

        {/* Parte inferior */}
        <div className="grid grid-cols-3 gap-4 w-full">
          <div className="text-start min-w-0 flex flex-col">
            <div className="text-xs text-gray-500 mb-2 h-3 flex items-center justify-center whitespace-nowrap">
              Total de Citas
            </div>
            <div className="text-lg font-bold text-gray-900 text-start">
              {stats?.totalCitas?.toLocaleString() || '7,265'}
            </div>
          </div>
          <div className="text-start min-w-0 flex flex-col">
            <div className="text-xs text-gray-500 mb-2 h-3 flex items-center justify-center whitespace-nowrap">
              Próximas Citas
            </div>
            <div className="text-lg font-bold text-gray-900 text-start">
              {stats?.proximasCitas?.toLocaleString() || '7,265'}
            </div>
          </div>
          <div className="text-start min-w-0 flex flex-col">
            <div className="text-xs text-gray-500 mb-2 h-3 flex items-center justify-center whitespace-nowrap">
              Reclamaciones
            </div>
            <div className="text-lg font-bold text-gray-900 text-start">
              {stats?.reclamaciones?.toLocaleString() || '7,265'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
